import { useAuth } from "../contexts/AuthContext";
import { useFirebaseWishesDataFetch } from "../contexts/FirebaseConnectionContext";
import LandingPageMainSection from "../components/landingPage/LandingPageMainSection";
import LandingPageDisconnectedElement from "../components/landingPage/LandingPageDisconnectedElement"
import LandingPageLoggedInElement from "../components/landingPage/LandingPageLoggedInElement"
import GlobalNavLink from "../components/parts/navlinks/GlobalNavLink";
import wandImg from "../assets/images/svg/wand";
import friendsImg from "../assets/images/svg/friends";
import christmasGift from "../assets/images/christmasGift.jpg";
import joy from "../assets/images/joy.jpg";
import profil1 from "../assets/images/profil1.jpg";
import profil2 from "../assets/images/profil2.jpg";
import profil3 from "../assets/images/profil3.jpg";

const LandingPage = () => {
  const { currentUser } = useAuth();
  const { giftsList } = useFirebaseWishesDataFetch();

  const cssMain = "w-full flexJustifyItemsCenter flex-col"
  const mainCss = currentUser ? `${cssMain} main-logged` : `${cssMain} main-disconnected`
  const bigImgCss = `w-24 h-24 rounded-full`;
  const smallImgCss = `w-10 h-10 rounded-full cursor-pointer md:w-16 md:h-16`;
  const giftImgAlt = "un cadeau de Noël";
  const friendsImgArray = [profil1, profil2, profil3];

  const friendsArray = [];
  for (let i = 0; i < friendsImgArray.length; i++) {
    friendsArray.push(
      <GlobalNavLink
        key={i}
        type="imgLink"
        to={currentUser ? "/friends" : "/login"}
        picture={
          <img
            className={smallImgCss}
            src={friendsImgArray[i]}
            alt="Une personne"
          />
        }
        css={smallImgCss}
      />
    );
  }

  const wishesDiv = (
    <div className="h-full w-full sm:pl-24 sm:gap-6 sm:flex sm:justify-start sm:items-center sm:flex-col">
      <span className="flex justify-end items-center text-2xl font-bold text-darkRed pl-20 pt-3 text-right sm:hidden">
        Le cadeau parfait à portée de clics !
      </span>
      <div className="gap-6 mt-2 w-full hidden sm:flex sm:justify-start sm:items-center">
        <span className="text-2xl font-bold text-darkRed">
          Souhaits que vous avez formulés :
        </span>
      </div>
      <div className="hidden mt-6 justify-end gap-3 sm:flex sm:justify-start sm:w-full sm:mt-0">
        {giftsList &&
          giftsList.map((gift) => (
            <GlobalNavLink
              key={gift.id}
              type="imgLink"
              to={currentUser ? "/wishes" : "/login"}
              picture={
                <img
                  className={smallImgCss}
                  src={christmasGift}
                  alt={giftImgAlt}
                />
              }
              css={smallImgCss}
            />
          ))}
      </div>
    </div>
  );

  const friendsDiv = (loggedInDiv = false) => {
    const subDiv = loggedInDiv ? <>
      <span className="flex justify-start items-center w-5/6 text-2xl pr-3 font-bold text-darkRed sm:hidden">
        Faites donc plaisir à vos amis !
      </span>
      <div className="gap-6 w-full hidden sm:flex sm:justify-start sm:items-center lg:mt-0">
        <span className="text-xl font-bold text-darkRed sm:text-2xl">
          Réaliser les souhaits de vos amis :
        </span>
      </div>
      <div className="hidden text-lg mt-6 justify-end gap-3 sm:flex sm:justify-start sm:w-full sm:mt-3 sm:text-xl md:mt-0">
        {friendsArray}
      </div>
    </> : <>
      <div className="gap-6 flexJustifyItemsCenter">
        <span className="text-xl text-darkRed md:text-2xl">
          pour exaucer leurs souhaits
        </span>
        <img
          className={bigImgCss}
          src={joy}
          alt="Des gens joyeux qui sautent"
        />
      </div>
      <div className="flex text-lg mt-6 justify-end gap-3 md:w-full md:mt-0 md:text-xl">
        {friendsArray}
      </div>
    </>

    return (
      <div className="h-full w-full mt-2 md:gap-6 md:flex md:justify-start md:items-center md:flex-col">
        {subDiv}
      </div>
    )
  };

  const firstDivSpanNavlink = [
    {
      to: currentUser ? "/wishes" : "/login",
      txt: "Souhaits",
      css: "",
      img: wandImg,
      alt: "Une baguette magique",
    },
    {
      to: currentUser ? "/friends" : "/login",
      txt: "Amis",
      css: "",
      img: friendsImg,
      alt: "Des amis",
    },
  ];

  return (
    <main className={mainCss}>
      <LandingPageMainSection />
      {
        currentUser ? <>
          <div className="w-full h-screen bg-white flexJustifyItemsCenter flex-col gap-8 py-14 global-px shadow-md shadow-ivory">
            <LandingPageLoggedInElement
              cssMainContent="bg-ivory shadow-xl shadow-ivroy pr-6 flex-col items-end sm:flex-row-reverse sm:justify-end sm:items-start"
              cssSeparator="bg-darkRed"
              cssImg="left-0"
              img={[wandImg, christmasGift]}
              imgAlt="Un cadeaux"
              navlink={["/wishes", "Souhaits"]}
              child={wishesDiv}
            />
            <LandingPageLoggedInElement
              cssGlobal="flex-row-reverse"
              cssMainContent="border-darkYellow border-4 shadow-lg justify-start pl-6 gap-4 flex-col"
              cssSeparator="bg-darkYellow"
              cssImg="-left-[7.5rem]"
              img={[friendsImg, joy]}
              imgAlt="Des gens joyeux qui sautent"
              navlink={["/friends", "Amis"]}
              child={currentUser ? friendsDiv(true) : friendsDiv(false)}
            />
          </div>
        </> : <>
          <div className="w-full flexJustifyItemsCenter flex-col">
            <div className="relative w-full flexJustifyItemsCenter z-40">
              <div className="absolute flexJustifyItemsCenter md:hidden md:w-5/12 md:h-24 lg:w-4/12">
                <GlobalNavLink
                  type="landingPageBtn"
                  to={currentUser ? "/wishes" : "/login"}
                  txt="Je commence ma liste"
                  css="bg-darkRed w-full h-full flexJustifyItemsCenter text-white font-bold text-xl text-center rounded-lg px-6 py-3 shadow shadow-darkRed md:text-3xl"
                />
              </div>
            </div>
            <LandingPageDisconnectedElement
              cssGlobal="pt-12 pb-10 z-10 drop-shadow-xl md:pt-20"
              cssFirstDiv="flex-row"
              cssFirstDivSpan={[
                "",
                "bg-white px-2 rounded-md shadow-md shadow-white",
              ]}
              cssFirstDivImg="w-52 h-48"
              firstDivSpanTxt={["Créez vos listes de souhaits et ", "partagez-les !"]}
              firstDivSpanNavlink={firstDivSpanNavlink[0]}
              cssSecondDiv="gap-6 flexJustifyItemsCenter"
              imgSecondDiv={[bigImgCss, christmasGift, giftImgAlt]}
              cssSecondDivSpan="text-lg text-right text-darkRed"
              secondDivSpanTxt="C'est facile et vous décidez qui peut les voir"
              secondDivChild={null}
              cssThirdDivSpan="pl-2 border-l-2"
              thirdDivSpanTxt={[
                "Fini les cadeaux qui ne vous intéressent pas...",
                "... et le manque d'idées pour faire plaisir : rien de plus simple pour toujours trouver le cadeau idéal !",
              ]}
            />
            <LandingPageDisconnectedElement
              cssGlobal="py-10 bg-gradient-to-b-whiteOrange shadow-md shadow-ivory"
              cssFirstDiv="flex-row-reverse"
              cssFirstDivSpan={[
                "text-right",
                "text-right bg-ivory px-2 rounded-md shadow-xl shadow-ivory",
              ]}
              firstDivSpanTxt={["Accèdez aux listes de vos ", "amis"]}
              firstDivSpanNavlink={firstDivSpanNavlink[1]}
              cssSecondDiv="h-full md:flex md:justify-around md:items-center md:flex-col"
              imgSecondDiv={[null, null, null]}
              cssSecondDivSpan=""
              secondDivSpanTxt=""
              secondDivChild={currentUser ? friendsDiv(true) : friendsDiv(false)}
              cssThirdDivSpan="pr-2 border-r-2 text-right"
              thirdDivSpanTxt={[
                "Chacun est libre de créer ses propres listes...",
                "... et d'en donner l'accès à qui il souhaite",
              ]}
            />
          </div>
        </>
      }
    </main>
  )
}

export default LandingPage
